module.exports = " <div class=publish-fields> <div class=form-group> <label class=block>{{ translate('cp.fieldset') }}</label> <small class=help-block>{{ translate('cp.asset_fieldset_instructions') }}</small> <fieldset-fieldtype :data.sync=fieldset></fieldset-fieldtype> </div> <div class=form-group> <button class=\"btn btn-default\" @click=submit>Next Step</button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html-loader!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/statamic/resources/js/components/assets/Container/Wizard/FieldsetFields.vue
// module id = 345
// module chunks = 0